module.exports = __webpack_public_path__ + "img/4.3de5eb90.png";